import { render, staticRenderFns } from "./CourseSet.vue?vue&type=template&id=af474f7e&scoped=true&"
import script from "./CourseSet.vue?vue&type=script&lang=js&"
export * from "./CourseSet.vue?vue&type=script&lang=js&"
import style0 from "./CourseSet.vue?vue&type=style&index=0&id=af474f7e&prod&lang=scss&scoped=true&"
import style1 from "./CourseSet.vue?vue&type=style&index=1&id=af474f7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af474f7e",
  null
  
)

export default component.exports